import React, { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { useContent } from "@/lib/content";

const FALLBACK = [
  "100% Pass Support",
  "Free Retake Coaching",
  "EMI Available",
  "Placement Assistance",
  "One-to-One Mentor",
  "U-Shape Interactive Classes",
  "Parent Counselling",
  "Top Rank Producers",
];

export default function Marquee() {
  const { content } = useContent();
  const items = content.marquee_items?.length ? content.marquee_items : FALLBACK;
  const [ready, setReady] = useState(false);
  useEffect(() => setReady(true), []);
  return (
    <div className="bg-[#73c3ff] border-y border-[#59b5f9]/40 overflow-hidden">
      <div className="max-w-[100vw] py-3 flex">
        <div className={`flex gap-10 whitespace-nowrap ${ready ? "animate-[marquee_28s_linear_infinite]" : ""}`} style={{ animationName: "marquee" }}>
          {[...items, ...items, ...items].map((t, i) => (
            <span key={i} className="flex items-center gap-2 font-inter text-sm font-semibold text-[#002570]">
              <Sparkles className="w-3.5 h-3.5" />
              {t}
            </span>
          ))}
        </div>
      </div>
      <style>{`@keyframes marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-33.3333%); } }`}</style>
    </div>
  );
}
